import { Translator } from '../../modules/translate';
import { Config } from '../../modules/Config';
import { MenuItemWrapper } from '../MenuItemWrapper/MenuItemWrapper';
import * as s from './SignIn.scss';

export interface SignInProps {
  config: Config;
  t: Translator;
}

const buildQueryParamString = (dict: Object) =>
  Object.keys(dict)
    .filter((param) => dict[param as keyof typeof dict])
    .map((param) => [param, encodeURIComponent(dict[param as keyof typeof dict] as any)].join('='))
    .join('&');

const createMobileLoginLink = (config: Config) => {
  const params = {
    view: 'sign-up',
    sendEmail: 'true',
    loginCompName: 'SignUp_Mobile',
    referralInfo: 'SignUp_Mobile',
    postSignUp: 'https://www.wix.com/my-account/sites/',
    postLogin: 'https://www.wix.com/my-account/sites/',
    overrideLocale: config.getLanguage() === 'en' ? null : config.getLanguage(),
  };

  const queryParams = buildQueryParamString(params);
  return `https://users.wix.com/signin?${queryParams}`;
};

const createDesktopLoginLink = (config: Config) => {
  const desktopTabletParams = {
    view: 'sign-up',
    sendEmail: 'true',
    loginCompName: 'SignUp_H',
    referralInfo: 'SignUp_H',
    postLogin: config.getPostLogin(),
    postSignUp: config.getPostSignUp(),
    overrideLocale: config.getLanguage() === 'en' ? null : config.getLanguage(),
  };

  const queryParamsString = buildQueryParamString(desktopTabletParams);
  return `https://users.wix.com/signin?${queryParamsString}`;
};

// data-hook="login" added specially for https://support.wix.com page
export const SignIn = ({ config, t }: SignInProps): string => {
  const desktopLink = createDesktopLoginLink(config);
  const mobileLink = createMobileLoginLink(config);
  return MenuItemWrapper({
    className: s.signInContainer,
  })(`
      <a
        class="${s.signIn} ${s.desktopOnly}"
        href="${desktopLink}"
        data-hook="login"
        data-bi-name="sign_in"
      >
        ${t('menu_sign_in')}
      </a>
      <a
        class="${s.signIn} ${s.mobileOnly}"
        href="${mobileLink}"
        data-hook="login"
        data-bi-name="sign_in"
      >
        ${t('menu_sign_in')}
      </a>
`);
};
